import axios from '@axios';

export default {
  fetchTickets(params: object) {
    return axios.get('/support/tickets', { params });
  },

  fetchTicketById(id: number) {
    return axios.get(`/support/tickets/${id}`);
  },

  createTicket(formData: FormData) {
    return axios.post('/support/tickets', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  replyToTicket(id: number, formData: FormData) {
    return axios.post(`/support/tickets/${id}/reply`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};
